import { z } from 'zod';
import { addressSchema } from '../common/address.js';
import { contactSchema } from './contact.js';
import { personalInfoSchema } from './personal-info.js';
export const profileSchema = z.object({
    id: z.string().optional(),
    salutation: z.string().optional(),
    full_name: z.string().optional(),
    ...personalInfoSchema.shape,
    first_name: personalInfoSchema.shape.first_name.optional(),
    last_name: personalInfoSchema.shape.last_name.optional(),
    member_since: z.string().optional(),
    email_address: z.email().optional(),
    real_estate_advisor: z.string().default('Default User'),
    real_estate_advisor_email: z.email().optional(),
    ...contactSchema.shape,
    phone_mobile: contactSchema.shape.phone_mobile.optional(),
    phone_mobile_country_code: contactSchema.shape.phone_mobile_country_code.optional(),
    phone_work_country_code: contactSchema.shape.phone_work_country_code.optional(),
    phone_other_country_code: contactSchema.shape.phone_other_country_code.optional(),
    home_address: addressSchema.optional(),
    mailing_address: addressSchema.optional(),
});
